import { Navigate, Route, Routes } from 'react-router-dom';
import './App.css';
import Login from './pages/Login';
import Home from './pages/Home';
import { useState, useEffect } from 'react';
import RefrshHandler from './RefrshHandler';
import Event from './pages/Event';
import Sidebar from './pages/Sidebar';
import Franchise from './pages/Franchise';
import EventFormModal from './pages/EventFormModal';
import { useLocation, useNavigate } from 'react-router-dom';
import Programs from './pages/programs/Programs';
import ProgramEdit from './pages/programs/ProgramEdit';
import ProgramCreate from './pages/programs/ProgramCreate';
import Languages from './pages/Languages/Languages';
import ProgramTemplates from './pages/ProgramTemplate/ProgramTemplates';
import ProgramTemplateCreate from './pages/ProgramTemplate/ProgramTemplateCreate';

function App() {
  // Initialize isAuthenticated based on the presence of a token
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return Boolean(localStorage.getItem('token'));
  });
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Check authentication status when the location changes
    const token = localStorage.getItem('token');
    if (token) {
      setIsAuthenticated(true);
      // Redirect from auth pages to home if authenticated
      if (['/', '/login', '/signup'].includes(location.pathname)) {
        navigate('/home', { replace: true });
      }
    } else {
      setIsAuthenticated(false);
      // Redirect to login if not on a public route
      if (!['/login', '/signup'].includes(location.pathname)) {
        navigate('/login', { replace: true });
      }
    }
  }, [location, navigate]);

  const PrivateRoute = ({ element }) => {
    return isAuthenticated ? element : <Navigate to="/login" />;
  };

  return (
    <div className="App">
      {/* Conditionally render Sidebar based on authentication */}
      {isAuthenticated && <Sidebar />}

      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<Login setIsAuthenticated={setIsAuthenticated} />} />
        
        {/* Private Routes */}
        <Route path="/home" element={<PrivateRoute element={<Home />} />} />
        <Route path="/event" element={<PrivateRoute element={<Event />} />} />
        <Route path="/franchise" element={<PrivateRoute element={<Franchise />} />} />
        <Route path="/event/new" element={<PrivateRoute element={<EventFormModal />} />} />
        <Route path="/event/edit/:id" element={<PrivateRoute element={<EventFormModal />} />} />
        <Route path="/programs" element={<Programs />} />
<Route path="/programs/edit/:id" element={<ProgramEdit />} />
<Route path="/programs/create" element={<ProgramCreate />} />
<Route path="/languages" element={<Languages />} />
<Route path="/program-templates" element={<ProgramTemplates />} />
<Route path="/program-templates/create" element={<ProgramTemplateCreate />} />
    
      </Routes>
    </div>
  );
}

export default App;